import { useEffect, useRef, useState } from 'react'
import { Check } from 'lucide-react'

export default function SharedMemberPicker({ allMembers, selected, onConfirm, onCancel }) {
    const [search, setSearch] = useState('')
    const [picked, setPicked] = useState(selected || [])
    const ref = useRef(null)
    const inputRef = useRef(null)

    useEffect(() => {
        inputRef.current?.focus()
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onCancel()
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [onCancel])

    const filtered = allMembers.filter(m => {
        const name = (m.full_name || m.email || '').toLowerCase()
        return name.includes(search.toLowerCase())
    })

    const toggle = (id) => {
        setPicked(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id])
    }

    const toggleAll = () => {
        if (picked.length === allMembers.length) {
            setPicked([])
        } else {
            setPicked(allMembers.map(m => m.id))
        }
    }

    return (
        <div className="shared-member-picker" ref={ref}>
            <div className="shared-member-picker-header">Selectează membrii</div>
            <input
                ref={inputRef}
                className="inline-input shared-member-picker-search"
                placeholder="Caută membru..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                onKeyDown={e => e.key === 'Escape' && onCancel()}
            />
            <div className="shared-member-picker-list">
                {!search && (
                    <label className="shared-member-picker-item select-all" onClick={toggleAll}>
                        <span className={`shared-member-picker-check ${picked.length === allMembers.length ? 'checked' : ''}`}>
                            {picked.length === allMembers.length && <Check size={10} />}
                        </span>
                        <span className="shared-member-picker-name">Toți membrii ({allMembers.length})</span>
                    </label>
                )}
                {filtered.map(m => (
                    <label key={m.id} className="shared-member-picker-item" onClick={() => toggle(m.id)}>
                        <span className={`shared-member-picker-check ${picked.includes(m.id) ? 'checked' : ''}`}>
                            {picked.includes(m.id) && <Check size={10} />}
                        </span>
                        <span className="shared-member-picker-avatar" style={{ background: `hsl(${(m.full_name?.length || 0) * 37 % 360}, 50%, 40%)` }}>
                            {m.full_name?.charAt(0).toUpperCase() || '?'}
                        </span>
                        <span className="shared-member-picker-name">{m.full_name || m.email || 'Utilizator'}</span>
                    </label>
                ))}
                {filtered.length === 0 && <div className="shared-member-picker-empty">Niciun rezultat</div>}
            </div>
            <div className="shared-member-picker-actions">
                <button className="btn btn-secondary btn-sm" onClick={onCancel}>Anulează</button>
                <button className="btn btn-primary btn-sm" onClick={() => onConfirm(picked)} disabled={picked.length === 0}>
                    Confirmă ({picked.length})
                </button>
            </div>
        </div>
    )
}
